import type { ReactNode } from 'react';

export const symbol_table_edit: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-430h270v-190H180v190Zm0-250h600v-100H180v100ZM550-80q-12.75 0-21.37-8.63Q520-97.25 520-110v-68q0-12.44 5-23.72T538-221l202.74-201.78Q750-432 761-436q11-4 22-4 12 0 23 4.5t20 13.5l37 37q9 9 13 20t4 22q0 11-4.5 22.5t-13.67 20.72L661-98q-8 8-19.28 13-11.28 5-23.72 5h-68Zm270-263-37-37 37 37ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v241q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-81H510v190h102q10.5 0 14.25 9.5T623-404L476-258q-7 7-16.5 3.46T450-268v-102H180v190h240q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180Zm0-60v-190 190Zm330-250v-190 190Zm70 290h38l121-122-37-37-122 121v38Zm141-141-19-18 37 37-18-19Z"
		/>
	</svg>
);
